import React from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { BarChartIcon, TrendingUpIcon, PieChartIcon, AreaChartIcon, LineChartIcon, MapIcon, FilterIcon, SearchIcon, DownloadIcon, FileTextIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function VeilleStrategiquePage() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-4712">
      <Navbar data-id="element-4713" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-blue-50 to-white relative overflow-hidden" data-id="element-4714">
        <div className="container mx-auto px-4 relative z-10" data-id="element-4715">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-4716">
            <div className="lg:w-1/2" data-id="element-4717">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} data-id="element-4718">
                <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4719">
                  Fonctionnalité
                </span>
                <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6" data-id="element-4720">
                  Analyse et veille stratégique
                </h1>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-4721">
                  Transformez les données en décisions stratégiques. Notre
                  plateforme d'analyse vous offre une vision claire du marché
                  des appels d'offres pour optimiser votre stratégie
                  commerciale.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-4722">
                  <Button variant="primary" size="lg" className="shadow-lg shadow-blue-500/20" data-id="element-4723">
                    Essayer gratuitement
                  </Button>
                  <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-4724">
                    Voir la démo
                  </Button>
                </div>
              </motion.div>
            </div>
            <div className="lg:w-1/2" data-id="element-4725">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="relative" data-id="element-4726">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-600 to-yellow-500 rounded-2xl blur opacity-20" data-id="element-4727"></div>
                <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 relative" data-id="element-4728">
                  <div className="flex items-center justify-between mb-6" data-id="element-4729">
                    <h3 className="font-semibold text-gray-900" data-id="element-4730">
                      Tableau de bord analytique
                    </h3>
                    <div className="flex items-center space-x-2" data-id="element-4731">
                      <select className="text-sm border border-gray-300 rounded px-2 py-1" data-id="element-4732">
                        <option data-id="element-4733">Dernier trimestre</option>
                        <option data-id="element-4734">6 derniers mois</option>
                        <option data-id="element-4735">Cette année</option>
                      </select>
                      <button className="p-1 bg-gray-100 rounded hover:bg-gray-200" data-id="element-4736">
                        <DownloadIcon size={16} data-id="element-4737" />
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-4738">
                    <div className="bg-blue-50 p-4 rounded-lg" data-id="element-4739">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-4740">
                        Appels d'offres identifiés
                      </div>
                      <div className="text-2xl font-bold text-blue-900" data-id="element-4741">
                        1,248
                      </div>
                      <div className="text-xs text-green-600 flex items-center mt-1" data-id="element-4742">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-4743">
                          <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" data-id="element-4744" />
                        </svg>
                        +12.5% vs période précédente
                      </div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg" data-id="element-4745">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-4746">
                        Taux de correspondance
                      </div>
                      <div className="text-2xl font-bold text-green-700" data-id="element-4747">
                        76%
                      </div>
                      <div className="text-xs text-green-600 flex items-center mt-1" data-id="element-4748">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-4749">
                          <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" data-id="element-4750" />
                        </svg>
                        +4.2% vs période précédente
                      </div>
                    </div>
                  </div>
                  <div className="mb-6" data-id="element-4751">
                    <div className="flex justify-between items-center mb-2" data-id="element-4752">
                      <div className="text-sm font-medium" data-id="element-4753">
                        Répartition par secteur
                      </div>
                      <div className="text-xs text-blue-600" data-id="element-4754">Voir détails</div>
                    </div>
                    <div className="h-40 bg-gray-50 rounded-lg p-4 flex items-end space-x-4" data-id="element-4755">
                      <div className="flex flex-col items-center" data-id="element-4756">
                        <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                        height: '60%'
                      }} data-id="element-4757"></div>
                        <div className="text-xs mt-1" data-id="element-4758">BTP</div>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-4759">
                        <div className="w-8 bg-blue-400 rounded-t-sm" style={{
                        height: '85%'
                      }} data-id="element-4760"></div>
                        <div className="text-xs mt-1" data-id="element-4761">IT</div>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-4762">
                        <div className="w-8 bg-blue-300 rounded-t-sm" style={{
                        height: '45%'
                      }} data-id="element-4763"></div>
                        <div className="text-xs mt-1" data-id="element-4764">Santé</div>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-4765">
                        <div className="w-8 bg-blue-200 rounded-t-sm" style={{
                        height: '30%'
                      }} data-id="element-4766"></div>
                        <div className="text-xs mt-1" data-id="element-4767">Énergie</div>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-4768">
                        <div className="w-8 bg-blue-100 rounded-t-sm" style={{
                        height: '20%'
                      }} data-id="element-4769"></div>
                        <div className="text-xs mt-1" data-id="element-4770">Autres</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-4771">
                    <span className="text-gray-500" data-id="element-4772">
                      Mis à jour il y a 2 heures
                    </span>
                    <a href="#" className="text-blue-600 font-medium" data-id="element-4773">
                      Rapport complet
                    </a>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-yellow-100 to-transparent opacity-70" data-id="element-4774"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-radial from-blue-50 to-transparent opacity-70" data-id="element-4775"></div>
      </section>
      {/* Features Section */}
      <section className="py-20" data-id="element-4776">
        <div className="container mx-auto px-4" data-id="element-4777">
          <div className="text-center mb-16" data-id="element-4778">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4779">
              Caractéristiques
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-4780">
              Des analyses puissantes pour des décisions éclairées
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-4781">
              Notre plateforme d'analyse vous permet de suivre les tendances du
              marché et d'identifier les meilleures opportunités pour votre
              entreprise.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4782">
            {[{
            icon: <BarChartIcon size={32} data-id="element-4783" />,
            title: 'Tableaux de bord personnalisés',
            description: 'Créez des tableaux de bord sur mesure pour suivre les indicateurs qui comptent le plus pour votre activité.'
          }, {
            icon: <TrendingUpIcon size={32} data-id="element-4784" />,
            title: 'Analyse des tendances',
            description: 'Identifiez les tendances émergentes dans votre secteur pour anticiper les opportunités futures.'
          }, {
            icon: <PieChartIcon size={32} data-id="element-4785" />,
            title: 'Segmentation du marché',
            description: "Analysez la répartition des appels d'offres par secteur, région, budget et type de procédure."
          }].map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-4786">
                <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-5" data-id="element-4787">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4788">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-4789">{feature.description}</p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Dashboard Preview */}
      <section className="py-20 bg-gray-50" data-id="element-4790">
        <div className="container mx-auto px-4" data-id="element-4791">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-4792">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-4793">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4794">
                Visualisation intuitive
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-4795">
                Des rapports détaillés et exploitables
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-4796">
                Transformez des données complexes en insights actionnables grâce
                à nos outils de visualisation avancés.
              </p>
              <div className="space-y-5" data-id="element-4797">
                {[{
                icon: <AreaChartIcon size={24} data-id="element-4798" />,
                title: 'Analyse des opportunités',
                description: "Visualisez la distribution des appels d'offres correspondant à votre profil et identifiez les meilleures opportunités."
              }, {
                icon: <LineChartIcon size={24} data-id="element-4799" />,
                title: 'Suivi de performance',
                description: "Mesurez votre taux de succès et comparez-le aux moyennes du secteur pour identifier vos points forts et axes d'amélioration."
              }, {
                icon: <MapIcon size={24} data-id="element-4800" />,
                title: 'Cartographie des marchés',
                description: "Explorez la répartition géographique des appels d'offres pour optimiser votre stratégie d'expansion territoriale."
              }].map((feature, index) => <div key={index} className="flex items-start" data-id="element-4801">
                    <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0" data-id="element-4802">
                      {feature.icon}
                    </div>
                    <div data-id="element-4803">
                      <h3 className="font-bold text-gray-900 mb-1" data-id="element-4804">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600" data-id="element-4805">{feature.description}</p>
                    </div>
                  </div>)}
              </div>
            </motion.div>
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-4806">
              <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200" data-id="element-4807">
                <div className="flex items-center justify-between mb-6" data-id="element-4808">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-4809">
                    Rapport mensuel - Octobre 2025
                  </h3>
                  <div data-id="element-4810">
                    <Button variant="outline" size="sm" className="flex items-center" data-id="element-4811">
                      <DownloadIcon size={16} className="mr-2" data-id="element-4812" />
                      Exporter
                    </Button>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-4813">
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4814">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-4815">
                      Appels d'offres
                    </div>
                    <div className="text-xl font-bold text-gray-900" data-id="element-4816">328</div>
                    <div className="text-xs text-green-600 flex items-center mt-1" data-id="element-4817">
                      +18% vs sept.
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4818">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-4819">
                      Soumissions
                    </div>
                    <div className="text-xl font-bold text-gray-900" data-id="element-4820">42</div>
                    <div className="text-xs text-green-600 flex items-center mt-1" data-id="element-4821">
                      +5% vs sept.
                    </div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4822">
                    <div className="text-xs text-gray-500 mb-1" data-id="element-4823">
                      Taux de succès
                    </div>
                    <div className="text-xl font-bold text-gray-900" data-id="element-4824">24%</div>
                    <div className="text-xs text-green-600 flex items-center mt-1" data-id="element-4825">
                      +2% vs sept.
                    </div>
                  </div>
                </div>
                <div className="mb-6" data-id="element-4826">
                  <div className="flex justify-between items-center mb-2" data-id="element-4827">
                    <div className="text-sm font-medium" data-id="element-4828">
                      Répartition par montant
                    </div>
                  </div>
                  <div className="h-48 bg-gray-50 rounded-lg p-4" data-id="element-4829">
                    {/* Pie chart mockup */}
                    <div className="h-full w-full flex items-center justify-center relative" data-id="element-4830">
                      <div className="absolute w-32 h-32 rounded-full bg-blue-500 opacity-20" data-id="element-4831"></div>
                      <div className="absolute w-32 h-32 rounded-full" style={{
                      background: 'conic-gradient(#1E40AF 0% 35%, #3B82F6 35% 55%, #93C5FD 55% 70%, #DBEAFE 70% 100%)',
                      clipPath: 'circle(50% at center)'
                    }} data-id="element-4832"></div>
                      <div className="absolute w-16 h-16 rounded-full bg-white" data-id="element-4833"></div>
                      <div className="absolute right-0 top-0 flex flex-col space-y-2" data-id="element-4834">
                        <div className="flex items-center text-xs" data-id="element-4835">
                          <div className="w-3 h-3 bg-blue-800 rounded-sm mr-2" data-id="element-4836"></div>
                          <span data-id="element-4837">{'>'} 500K€ (35%)</span>
                        </div>
                        <div className="flex items-center text-xs" data-id="element-4838">
                          <div className="w-3 h-3 bg-blue-500 rounded-sm mr-2" data-id="element-4839"></div>
                          <span data-id="element-4840">100K€ - 500K€ (20%)</span>
                        </div>
                        <div className="flex items-center text-xs" data-id="element-4841">
                          <div className="w-3 h-3 bg-blue-300 rounded-sm mr-2" data-id="element-4842"></div>
                          <span data-id="element-4843">50K€ - 100K€ (15%)</span>
                        </div>
                        <div className="flex items-center text-xs" data-id="element-4844">
                          <div className="w-3 h-3 bg-blue-100 rounded-sm mr-2" data-id="element-4845"></div>
                          <span data-id="element-4846">{'<'} 50K€ (30%)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-4847">
                  <div className="flex justify-between items-center mb-2" data-id="element-4848">
                    <div className="text-sm font-medium" data-id="element-4849">
                      Principaux secteurs d'activité
                    </div>
                    <div className="text-xs text-blue-600" data-id="element-4850">Voir tous</div>
                  </div>
                  <div className="space-y-2" data-id="element-4851">
                    <div className="bg-gray-50 p-3 rounded-lg flex items-center justify-between" data-id="element-4852">
                      <span className="text-sm" data-id="element-4853">BTP & Construction</span>
                      <span className="text-sm font-medium" data-id="element-4854">42%</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg flex items-center justify-between" data-id="element-4855">
                      <span className="text-sm" data-id="element-4856">
                        Technologies de l'information
                      </span>
                      <span className="text-sm font-medium" data-id="element-4857">28%</span>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg flex items-center justify-between" data-id="element-4858">
                      <span className="text-sm" data-id="element-4859">
                        Santé & Équipements médicaux
                      </span>
                      <span className="text-sm font-medium" data-id="element-4860">15%</span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Competitive Analysis */}
      <section className="py-20" data-id="element-4861">
        <div className="container mx-auto px-4" data-id="element-4862">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-12" data-id="element-4863">
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-4864">
              <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4865">
                Avantage concurrentiel
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6" data-id="element-4866">
                Analyse concurrentielle
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-4867">
                Comprenez le paysage concurrentiel et positionnez
                stratégiquement votre entreprise pour maximiser vos chances de
                succès.
              </p>
              <div className="space-y-6" data-id="element-4868">
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-4869">
                  <h3 className="font-bold text-gray-900 mb-3" data-id="element-4870">
                    Identification des concurrents
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-4871">
                    Notre système identifie les entreprises qui soumissionnent
                    régulièrement aux mêmes appels d'offres que vous, vous
                    permettant de mieux comprendre votre environnement
                    concurrentiel.
                  </p>
                  <a href="#" className="text-blue-600 font-medium flex items-center" data-id="element-4872">
                    En savoir plus
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-4873" />
                  </a>
                </div>
                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100" data-id="element-4874">
                  <h3 className="font-bold text-gray-900 mb-3" data-id="element-4875">
                    Analyse des forces et faiblesses
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-4876">
                    Comparez vos taux de succès par secteur et type de marché
                    avec ceux de vos concurrents pour identifier vos avantages
                    concurrentiels et vos axes d'amélioration.
                  </p>
                  <a href="#" className="text-blue-600 font-medium flex items-center" data-id="element-4877">
                    En savoir plus
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-4878" />
                  </a>
                </div>
              </div>
            </motion.div>
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-4879">
              <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200" data-id="element-4880">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-4881">
                  Analyse concurrentielle - BTP & Construction
                </h3>
                <div className="mb-6" data-id="element-4882">
                  <div className="flex justify-between items-center mb-2" data-id="element-4883">
                    <div className="text-sm font-medium" data-id="element-4884">
                      Parts de marché estimées
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-4885">
                    <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4886">
                      <div className="flex justify-between mb-1" data-id="element-4887">
                        <span className="text-sm font-medium" data-id="element-4888">
                          Construct Plus (Vous)
                        </span>
                        <span className="text-sm" data-id="element-4889">18%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4890">
                        <div className="bg-blue-600 h-2 rounded-full" style={{
                        width: '18%'
                      }} data-id="element-4891"></div>
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4892">
                      <div className="flex justify-between mb-1" data-id="element-4893">
                        <span className="text-sm" data-id="element-4894">Bâtisseurs du Sud</span>
                        <span className="text-sm" data-id="element-4895">24%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4896">
                        <div className="bg-gray-500 h-2 rounded-full" style={{
                        width: '24%'
                      }} data-id="element-4897"></div>
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4898">
                      <div className="flex justify-between mb-1" data-id="element-4899">
                        <span className="text-sm" data-id="element-4900">MedBuild</span>
                        <span className="text-sm" data-id="element-4901">15%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4902">
                        <div className="bg-gray-500 h-2 rounded-full" style={{
                        width: '15%'
                      }} data-id="element-4903"></div>
                      </div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg" data-id="element-4904">
                      <div className="flex justify-between mb-1" data-id="element-4905">
                        <span className="text-sm" data-id="element-4906">Autres concurrents</span>
                        <span className="text-sm" data-id="element-4907">43%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-4908">
                        <div className="bg-gray-500 h-2 rounded-full" style={{
                        width: '43%'
                      }} data-id="element-4909"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-4910">
                  <div className="flex justify-between items-center mb-4" data-id="element-4911">
                    <div className="text-sm font-medium" data-id="element-4912">
                      Analyse comparative
                    </div>
                  </div>
                  <div className="overflow-x-auto" data-id="element-4913">
                    <table className="min-w-full bg-white border border-gray-200 text-sm" data-id="element-4914">
                      <thead data-id="element-4915">
                        <tr className="bg-gray-50" data-id="element-4916">
                          <th className="py-2 px-3 text-left border-b" data-id="element-4917">
                            Critère
                          </th>
                          <th className="py-2 px-3 text-left border-b" data-id="element-4918">Vous</th>
                          <th className="py-2 px-3 text-left border-b" data-id="element-4919">
                            Moyenne
                          </th>
                        </tr>
                      </thead>
                      <tbody data-id="element-4920">
                        <tr data-id="element-4921">
                          <td className="py-2 px-3 border-b" data-id="element-4922">Taux de succès</td>
                          <td className="py-2 px-3 border-b text-green-600 font-medium" data-id="element-4923">
                            24%
                          </td>
                          <td className="py-2 px-3 border-b" data-id="element-4924">18%</td>
                        </tr>
                        <tr data-id="element-4925">
                          <td className="py-2 px-3 border-b" data-id="element-4926">
                            Délai moyen de réponse
                          </td>
                          <td className="py-2 px-3 border-b text-yellow-600 font-medium" data-id="element-4927">
                            12 jours
                          </td>
                          <td className="py-2 px-3 border-b" data-id="element-4928">10 jours</td>
                        </tr>
                        <tr data-id="element-4929">
                          <td className="py-2 px-3 border-b" data-id="element-4930">Montant moyen</td>
                          <td className="py-2 px-3 border-b text-green-600 font-medium" data-id="element-4931">
                            320K€
                          </td>
                          <td className="py-2 px-3 border-b" data-id="element-4932">280K€</td>
                        </tr>
                        <tr data-id="element-4933">
                          <td className="py-2 px-3" data-id="element-4934">Diversité sectorielle</td>
                          <td className="py-2 px-3 text-red-600 font-medium" data-id="element-4935">
                            3 secteurs
                          </td>
                          <td className="py-2 px-3" data-id="element-4936">5 secteurs</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-20 bg-gray-50" data-id="element-4937">
        <div className="container mx-auto px-4" data-id="element-4938">
          <div className="text-center mb-16" data-id="element-4939">
            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4940">
              Témoignages
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-4941">
              Ce que disent nos clients
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-4942">
              Découvrez comment notre plateforme d'analyse aide les entreprises
              à prendre de meilleures décisions stratégiques.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4943">
            {[{
            quote: "Les tableaux de bord analytiques d'ElevateIT nous ont permis d'identifier des opportunités dans des secteurs que nous n'avions pas envisagés. Notre chiffre d'affaires a augmenté de 22% en un an.",
            author: 'Nadia Toumi',
            position: 'Directrice Stratégie, Groupe Méditerranée',
            image: 'https://randomuser.me/api/portraits/women/65.jpg'
          }, {
            quote: "Grâce à l'analyse concurrentielle, nous avons pu ajuster notre positionnement sur le marché et mieux cibler les appels d'offres où nous avons un avantage concurrentiel réel.",
            author: 'Hakim Berrada',
            position: 'PDG, TechSolutions Maroc',
            image: 'https://randomuser.me/api/portraits/men/54.jpg'
          }, {
            quote: "La visualisation des tendances du marché nous a permis d'anticiper l'évolution de notre secteur et d'adapter notre stratégie en conséquence. Un outil vraiment indispensable.",
            author: 'Leila Mansouri',
            position: 'Responsable Développement, Bâtisseurs du Sud',
            image: 'https://randomuser.me/api/portraits/women/33.jpg'
          }].map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-4944">
                <div className="mb-6" data-id="element-4945">
                  <svg className="h-8 w-8 text-yellow-400" fill="currentColor" viewBox="0 0 24 24" data-id="element-4946">
                    <path d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h10zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z" data-id="element-4947" />
                  </svg>
                </div>
                <p className="text-gray-700 mb-6" data-id="element-4948">"{testimonial.quote}"</p>
                <div className="flex items-center" data-id="element-4949">
                  <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4" data-id="element-4950" />
                  <div data-id="element-4951">
                    <h4 className="font-bold text-gray-900" data-id="element-4952">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-4953">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 bg-blue-900 text-white" data-id="element-4954">
        <div className="container mx-auto px-4" data-id="element-4955">
          <div className="max-w-4xl mx-auto text-center" data-id="element-4956">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-4957">
              Prêt à transformer vos données en décisions stratégiques?
            </h2>
            <p className="text-xl text-blue-100 mb-8" data-id="element-4958">
              Accédez à des analyses détaillées et des insights exploitables
              pour optimiser votre stratégie de réponse aux appels d'offres.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-4959">
              <Button variant="primary" size="lg" className="shadow-lg shadow-yellow-500/20 bg-yellow-500 hover:bg-yellow-400 text-blue-900" data-id="element-4960">
                Commencer gratuitement
              </Button>
              <Button variant="secondary" size="lg" className="bg-white text-blue-900 hover:bg-blue-50" data-id="element-4961">
                Demander une démo
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-20" data-id="element-4962">
        <div className="container mx-auto px-4" data-id="element-4963">
          <div className="text-center mb-16" data-id="element-4964">
            <span className="inline-block px-3 py-1 bg-blue-50 text-blue-800 text-sm font-semibold rounded-full mb-4" data-id="element-4965">
              Questions fréquentes
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-4966">
              Tout ce que vous devez savoir
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-4967">
              Nous avons rassemblé les questions les plus fréquentes concernant
              notre plateforme d'analyse et de veille stratégique.
            </p>
          </div>
          <div className="max-w-3xl mx-auto" data-id="element-4968">
            <div className="space-y-6" data-id="element-4969">
              {[{
              question: 'Quelles sont les sources de données utilisées pour vos analyses?',
              answer: "Nos analyses sont basées sur des données collectées à partir de plus de 200 sources d'appels d'offres publics et privés en Afrique du Nord et de l'Ouest. Nous enrichissons ces données avec des informations sur les attributions de marchés et les résultats des appels d'offres quand ils sont disponibles."
            }, {
              question: 'Puis-je personnaliser les tableaux de bord selon mes besoins?',
              answer: 'Absolument. Notre plateforme vous permet de créer des tableaux de bord personnalisés en sélectionnant les indicateurs et les visualisations qui sont les plus pertinents pour votre activité. Vous pouvez également définir des objectifs et suivre votre progression.'
            }, {
              question: "Comment l'analyse concurrentielle peut-elle m'aider?",
              answer: "L'analyse concurrentielle vous permet d'identifier vos principaux concurrents sur différents segments de marché, de comprendre leurs forces et faiblesses, et d'ajuster votre stratégie en conséquence. Cela vous aide à vous positionner sur les appels d'offres où vous avez un avantage concurrentiel réel."
            }, {
              question: 'Les rapports peuvent-ils être exportés?',
              answer: "Oui, tous les rapports et tableaux de bord peuvent être exportés en plusieurs formats (PDF, Excel, CSV) pour être partagés avec votre équipe ou intégrés dans vos présentations. Vous pouvez également programmer l'envoi automatique de rapports par email."
            }, {
              question: 'Quelle est la fréquence de mise à jour des données?',
              answer: "Les données sont mises à jour en temps réel pour les nouveaux appels d'offres. Les analyses de tendances et les rapports statistiques sont actualisés quotidiennement. Les analyses concurrentielles sont mises à jour mensuellement pour refléter les évolutions du marché."
            }].map((faq, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-4970">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-4971">
                    {faq.question}
                  </h3>
                  <p className="text-gray-600" data-id="element-4972">{faq.answer}</p>
                </div>)}
            </div>
            <div className="mt-10 text-center" data-id="element-4973">
              <p className="text-gray-600 mb-4" data-id="element-4974">
                Vous avez d'autres questions?
              </p>
              <Button variant="outline" size="lg" className="border-2 border-blue-900" data-id="element-4975">
                Contactez-nous
              </Button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-4976" />
      <FloatingCTA data-id="element-4977" />
    </div>;
}